import React, { Component } from 'react'
import JobList from '../../old_Components/Campus/CampusJobList'
import constant from '../../constant';
import queryString from 'query-string';
export default class jobList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FILTER_BY: 'ALL',
      LIMIT: 10,
      PAGE: 1,
      COUNT: undefined,
      LIST: undefined,
      KEYWORD: '',
    }
  }

  componentDidMount() {
    document.title = constant.title.JobList
    const qParam = queryString.parse(this.props?.location?.search)
    this.setState({
      FILTER_BY: qParam.f,
      PAGE: qParam.p,
      LIMIT: qParam.l,
      KEYWORD: qParam.k
    })


  }
  onFilterChange = (input) => {
    const { FILTER_BY, LIMIT, PAGE } = this.state
    this.setState({
      FILTER_BY: input,
    })
    window.location.href = constant.component.campusJobList.url + `?f=${input}&l=${LIMIT}&p=${PAGE}`
  }
  onLimitChange = (input) => {
    const { FILTER_BY, LIMIT, PAGE } = this.state
    this.setState({
      LIMIT: input
    })
    window.location.href = constant.component.campusJobList.url + `?f=${FILTER_BY}&l=${input}&p=${PAGE}`
  }
  onPageChange = (input) => {
    const { FILTER_BY, LIMIT, PAGE } = this.state
    this.setState({
      PAGE: input,
    })
    window.location.href = constant.component.campusJobList.url + `?f=${FILTER_BY}&l=${LIMIT}&p=${input}`
  }

  render() {

    const { COUNT, LIST } = this.state
    const qParam = queryString.parse(this.props?.location?.search)

    return (
      <React.Fragment>
        <JobList
          ATS_ENABLED={0}
          FILTER_BY={qParam.f}
          PAGE={qParam.p}
          LIMIT={qParam.l}
          KEYWORD={qParam.k}
          COUNT={COUNT}
          LIST={LIST}
          onFilterChange={(filter) => this.onFilterChange(filter)}
          onLimitChange={(limit) => this.onLimitChange(limit)}
          onPageChange={(page) => { this.onPageChange(page) }}

        />
      </React.Fragment>
    )
  }
}
